webpackJsonp([3],{

/***/ 132:
/***/ (function(module, exports) {

module.exports = {"url":"https://arbopasto.cnpgc.embrapa.br","api":"/services/trees_list_json.php?TOKEN_ACCESS=0dc72402be6fe1c1321a5062058696f1","image_base64":"/libraries/php-image-resize/lib/index64.php?w=450&h=450&image_path=","image_crop":"/libraries/php-image-resize/lib/index.php?w=450&h=450&image_path=","status":"/services/status.php","analytics":"UA-124202509-4","tracking":{"host":"https://bug.cnpgc.embrapa.br","key":"409619fc535e338fe598cfe0613438bb"},"support":"arbopasto@embrapa.br"}

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Update_vue__ = __webpack_require__(443);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    UpdateWrapper: __WEBPACK_IMPORTED_MODULE_0__components_Update_vue__["a" /* default */]
  },
  data: function data() {
    return {
      category: null,
      dialog: false,
      app: null
    };
  },

  localStorage: {
    user: {
      type: Object,
      default: {
        authenticated: false,
        name: '',
        email: '',
        picture: '',
        token: ''
      }
    },
    synchronized: {
      type: Number,
      default: 0
    },
    iosTryInstall: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    details: function details(app) {
      console.log('details');
      this.$refs.info.show(app);
    }
  },
  name: 'App'
});

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasUpdate: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    document.addEventListener('hasUpdate', function () {
      _this.hasUpdate = true;
    }, false);
  },

  methods: {
    update: function update() {
      window.location.reload();
    }
  }
});

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(206);
module.exports = __webpack_require__(408);


/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__db__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_webp__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_webp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_v_webp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_localstorage__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_analytics__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_airbrake_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_airbrake_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_airbrake_js__);
















var settings = __webpack_require__(132);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_analytics___default.a, {
  id: settings.analytics
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_v_webp___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__db__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_localstorage___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_localstorage___default.a, {
  name: 'ls',
  bind: true
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_analytics___default.a, {
  id: settings.analytics
});

var errbit = new __WEBPACK_IMPORTED_MODULE_13_airbrake_js___default.a({
  projectId: 1,
  projectKey: settings.tracking.key,
  host: settings.tracking.host,
  environment: "production"
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$err = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(error) {
    var params;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = {};


            if (error !== null && (typeof error === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(error)) === 'object') {
              if (error.response !== null && typeof error.response !== 'undefined' && error.response.data !== null && typeof error.response.data !== 'undefined') {
                params.info = error.response.data;
              }

              if (error.name !== null && typeof error.name !== 'undefined') {
                params.name = error.name;
              }
            }

            _context.next = 4;
            return errbit.notify({
              error: error,
              params: params
            });

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a, {
  theme: {
    primary: '#558B2F',
    secondary: '#9E9D24',
    accent: '#AEEA00',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50'
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */] },
  data: {
    trySync: true
  }
});

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 441:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34395f6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(445);
var normalizeComponent = __webpack_require__(128)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34395f6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Update_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd8b418e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Update_vue__ = __webpack_require__(444);
var normalizeComponent = __webpack_require__(128)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Update_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd8b418e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Update_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"multi-line":true,"timeout":60000},model:{value:(_vm.hasUpdate),callback:function ($$v) {_vm.hasUpdate=$$v},expression:"hasUpdate"}},[_vm._v("\n    Nova versão disponível!\n    "),_c('v-btn',{attrs:{"dark":"","flat":"","color":"info"},on:{"click":function($event){return _vm.update()}}},[_vm._v("\n      Atualizar\n    ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":""},on:{"click":function($event){_vm.hasUpdate = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('router-view',{attrs:{"category":_vm.category},on:{"info":_vm.details}})],1),_vm._v(" "),_c('update-wrapper')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(447);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var settings = __webpack_require__(132);

var options = [{ path: '/', name: 'Bem-vind@!', component: 'Home', props: false }, { path: '/trees', name: 'Catálogo de Árvores', component: 'Trees', props: false }];

var routes = options.map(function (route) {
  return {
    path: route.path,
    component: function component() {
      return __webpack_require__(448)("./" + route.component + '.vue');
    },
    name: route.name,
    props: route.props
  };
});

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_analytics___default.a, {
  id: settings.analytics,
  checkDuplicatedScript: true,
  debug: {
    sendHitTask: "production" === 'production'
  },
  router: router
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Home.vue": [
		459,
		1
	],
	"./Trees.vue": [
		460,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 448;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_idb__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_idb__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_idb___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_idb___default.a({
  version: 3,
  database: 'arbopasto',
  schemas: [{ tree: 'code, common_name, cached, getted' }]
}));

/***/ })

},[205]);


// WEBPACK FOOTER //
// static/js/app.e7ff6172c3e3b6d12b8b.js